module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/font/notokr-light.woff2
// module id = 62Ug
// module chunks = 0